export const config = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || 'development',
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  HIGHLIGHT_PROJECT_ID: import.meta.env.PROD ? 'jgoknqel' : undefined,
  SQUARE_CLIENT_ID: 'sq0idp-4iiZqsPlPewAlD9SKLxVoQ',
  SQUARE_CALLBACK_URL:
    import.meta.env.VITE_SQUARE_CALLBACK_URL ||
    'http://localhost:3000/square-callback',
};
